enum RouteNames {
  FIND_CLAIM = "find-claim",
  SELECT_SEARCH_METHOD = "select-search-method",
  WARRANTY_NUMBER = "warranty-number",
  SCAN_UPLOAD_INVOICE = "scan-upload-invoice",
  UPLOAD_INVOICE = "upload-invoice",
  UPLOAD_INVOICE_VERIFY_INFO = "upload-invoice/verify-info",
  SEARCH_BY_PERSONAL_INFO = "search-by-personal-info",
  CREATE_ACE2_CLAIM = "create-ace2-claim",
  CREATE_ACE_CLAIM = "create-ace-claim",
  NO_WARRANTY_FOUND = "not-found",
  WARRNTY_ID = ":warrnty_id",
  ADD_ACE2_WARRNTY_ITEM = "add-ace2-warrnty-item",
  CONTACT_SERVICE = "contact-service",
  CANCELLATION_SERVICE = "cancellation-service",
  SELECT_PLAN = "select-plan",
}

export default RouteNames;
